import { render, staticRenderFns } from "./Companys.vue?vue&type=template&id=94f97226"
import script from "./Companys.vue?vue&type=script&lang=js"
export * from "./Companys.vue?vue&type=script&lang=js"
import style0 from "./Companys.vue?vue&type=style&index=0&id=94f97226&prod&lang=sass&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports